'use client';

import { AppBar, CssBaseline, Toolbar } from '@mui/material';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
export default function SubAppBarComponent({ navBarData }: any) {
    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const pathName = usePathname();
    const path = pathName.split('/');
    const categoryData = navBarData.filter((item: any) => item?.id?.toLowerCase() === path?.at(1)?.toLocaleLowerCase());

    if (!Array.isArray(categoryData)) return <h1>Something went wrong...</h1>;

    const isActive = (href: string) => {
        switch (path.length) {
            case 2:
                return path.at(1) === href;
            case 3:
                return path.at(2) === href;
            default:
                return false;
        }
    };

    return (
        <>
            <CssBaseline />
            <AppBar
                color="default"
                position="sticky"
                sx={{ top: isSmScreen ? '55px' : '65px', zIndex: 20, display: isSmScreen ? 'none' : 'block' }}
            >
                {' '}
                <Toolbar
                    variant="dense"
                    sx={{ minHeight: '30px' }}
                    className="py-1 flex gap-x-5 md:justify-center overflow-auto m-auto"
                >
                    {categoryData[0]?.children?.primary?.length > 0 &&
                        categoryData[0]?.children?.primary?.map((item: any, idx: number) => {
                            return (
                                <Link
                                    href={item.href}
                                    key={idx}
                                    className={`${
                                        isActive(item?.href?.split('/')?.at(-1)) && 'text-blue-400 white'
                                    } whitespace-nowrap`}
                                >
                                    <h1 className="text-xs lg:text-sm">{item?.name}</h1>
                                </Link>
                            );
                        })}{' '}
                </Toolbar>
            </AppBar>
        </>
    );
}
